import { useTranslation } from 'react-i18next';
import { useError, useSnack } from '../../../hooks';
import { cancelAllBookings } from '../../../api/folders';
import { FolderCancelAllBookingsButton } from '@koob/booking';

/** KD-3842: "Cancel all bookings" of a TO client folder. */
const CancelAllBookings = ({ folderId, bookings, reload }) => {
  const { t } = useTranslation('folders');
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();

  const onSubmit = async ({ bookingIds, reason }) => {
    try {
      await cancelAllBookings(folderId, { bookingIds, reason });
      reload();
      notify(t('cancelAll.cancelSuccess'));
      return true;
    } catch (err) {
      sendErrorSnack(err);
      return false;
    }
  };

  return (
    <FolderCancelAllBookingsButton bookings={bookings} onSubmit={onSubmit} />
  );
};

export default CancelAllBookings;
